import firebase from '@firebase/app-compat'
import '@firebase/auth-compat'
import '@firebase/firestore-compat'
import '@firebase/functions-compat'
import '@firebase/storage-compat'

// FIREBASE INITIALIZATION
const config = {
  apiKey: 'AIzaSyBQgObjg-N6I5h3hbr6LhjS7rxyG-15KrY',
  authDomain: 'seoulspiceapp.firebaseapp.com',
  databaseURL: 'https://seoulspiceapp.firebaseio.com',
  projectId: 'seoulspiceapp',
  storageBucket: 'seoulspiceapp.appspot.com',
  messagingSenderId: '1062047185312'
}

const firebaseApp = firebase.initializeApp(config)
const db = firebaseApp.firestore()
const storage = firebaseApp.storage()
const { Timestamp } = firebase.firestore

if (window.location.hostname === '127.0.0.1') {
  firebase.auth().useEmulator('http://127.0.0.1:9099')
  db.useEmulator('127.0.0.1', 8081)
}

export { firebase, db, storage, Timestamp }

export default db
